import React, { createContext, useContext, useEffect, useRef } from "react";
import { useState } from "react";
import DeviceReportsIndex from "./DeviceReports/DeviceReportsIndex";
import StaffReportsIndex from "./StaffReports/StaffReportsIndex";
import TechTicketsIndex from "./TechnologyTickets/TechTicketsIndex";
import MaintenanceIndex from "./MaintenanceReports/MaintenanceIndex";
import ReactDatePicker from "react-datepicker";
import { fetchAdminData } from "../../JS/Connector";
import { formatDateToUsaMMDDYYYY, GetBuildingGrade, LogInSchoolID, userTimeZone } from "../../JS/Common";
import OtherHelpdeskTickets from "./OtherHelpdeskTickets/OtherHelpdeskTickets";
import Tab from "../../Components/Tab";
import OpenHelpdeskTicketsbyBuilding from "./OtherHelpdeskTickets/OpenHelpdeskTicketsbyBuilding";
import { UserContext } from "../../App";
import { log } from "../../JS/Logger";
import { useSelector } from "react-redux";
import useConfig from "../../Hooks/useConfig";

export const ReportDataContext = createContext();
export function SchoolReports() {
    const { show_grade_field } = useConfig();
    const { UserData } = useContext(UserContext);
    const [Alert, setAlerts] = useState("");
    const controller = new AbortController();
    const signal = controller.signal;
    const [Tabs, setTabs] = useState({
        DeviceReports: "active",
        StaffReports: "",
        HelpdeskTickets: "",
    });
    const [Onload, setOnload] = useState({
        DeviceOnload: false,
        StaffOnload: false,
        HelpdeskOnload: false,
    });
    const userTimeZone = useSelector(
        state => state?.authData?.UserTimeZone || "America/New_York"
    );
    const today = new Date(
        new Date().toLocaleString("en-US", { timeZone: userTimeZone })
    );

    const oneMonthAgo = new Date(today);

    oneMonthAgo.setDate(1);
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

    const day = today.getDate();

    const lastDayOfPreviousMonth = new Date(
        oneMonthAgo.getFullYear(),
        oneMonthAgo.getMonth() + 1,
        0
    ).getDate();

    oneMonthAgo.setDate(
        Math.min(day, lastDayOfPreviousMonth)
    );
    const [startDate, setStartDate] = useState(oneMonthAgo);
    const [endDate, setEndDate] = useState(today);
    const [GradeArray, setGradeArray] = useState([]);
    const [BuildingArray, setBuildingArray] = useState([]);
    const [grade, setgrade] = useState(null);
    const [building, setbuilding] = useState(0);
    const [AllReportData, setAllReportData] = useState({
        ticket_status_data: { data: [], loader: false },
        ticket_by_building_data: { data: [], loader: false },
        ticket_by_grade_data: { data: [], loader: false },
        part_used_data: { data: [], loader: false },
        kpi_data: { data: [], loader: false },
        staff_tickets_data: { data: [], loader: false },
        technology_tickets_close_rate_data: { data: [], loader: false },
        maintenance_tickets_close_rate_data: { data: [], loader: false },
        technology_tickets_data: { data: [], loader: false },
        maintenance_total_tickets_data: { data: [], loader: false },
        helpdesk_total_tickets_data: { data: [], loader: false },
        helpdesk_ticket_by_buildingfor_report: { data: [], loader: false },
        filter_data: {
            s_date: "", e_date: "", grade_id: null, building_id: null
        },
    });
    useEffect(() => {
        GetBuildingGrade({ setGradeArray, setBuildingArray });
        GetAllData(startDate, endDate, 0, 0)
        return () => controller.abort();
    }, [endDate]);

    async function GetAllData(sdate, edate, gradeid, buildingid) {

        if (gradeid == 0) {
            gradeid = null;
        }
        if (buildingid == 0) {
            buildingid = null;
        }
        const params = { sdate, edate, gradeid, buildingid }
        if (Tabs?.DeviceReports == "active" && !Onload?.DeviceOnload) {
            setAllReportData((prevState) => ({
                ...prevState,
                filter_data: { ...prevState?.filter_data, ...params },
            }))
            const apiCalls = [
                fetchAdminData(`/reports/ticket-by-status?schoolId=${LogInSchoolID}&startDate=${formatDateToUsaMMDDYYYY(sdate)}&endDate=${formatDateToUsaMMDDYYYY(edate)}&grade=${gradeid}&buildingId=${buildingid}`, 'ticket_status_data', setAllReportData, signal),
                fetchAdminData(`/reports/ticket-by-building?schoolId=${LogInSchoolID}&startDate=${formatDateToUsaMMDDYYYY(sdate)}&endDate=${formatDateToUsaMMDDYYYY(edate)}&grade=${gradeid}&buildingId=${buildingid}`, 'ticket_by_building_data', setAllReportData, signal),
                fetchAdminData(`/reports/tickets-by-grade?schoolId=${LogInSchoolID}&startDate=${formatDateToUsaMMDDYYYY(sdate)}&endDate=${formatDateToUsaMMDDYYYY(edate)}&grade=${gradeid}&buildingId=${buildingid}`, 'ticket_by_grade_data', setAllReportData, signal),
                fetchAdminData(`/reports/parts-average?schoolId=${LogInSchoolID}&startDate=${formatDateToUsaMMDDYYYY(sdate)}&endDate=${formatDateToUsaMMDDYYYY(edate)}&grade=${gradeid}&buildingId=${buildingid}`, 'part_used_data', setAllReportData, signal),
                fetchAdminData(`/reports/average-closure-rate?schoolId=${LogInSchoolID}&startDate=${formatDateToUsaMMDDYYYY(sdate)}&endDate=${formatDateToUsaMMDDYYYY(edate)}&grade=${gradeid}&buildingId=${buildingid}`, 'kpi_data', setAllReportData, signal),
            ];
            try {
                const responses = await Promise.all(apiCalls);
            } catch (error) {
                log.error(error)
            } finally {
                setOnload((prevState) => ({ ...prevState, DeviceOnload: true }))
            }
        }
        if (Tabs?.StaffReports == "active" && !Onload?.StaffOnload) {
            setAllReportData((prevState) => ({
                ...prevState,
                filter_data: { ...prevState?.filter_data, ...params },
            }))
            const apiCalls = [
                fetchAdminData(`/reports/tickets-created-by-staff?schoolId=${LogInSchoolID}&startDate=${formatDateToUsaMMDDYYYY(sdate)}&endDate=${formatDateToUsaMMDDYYYY(edate)}&grade=${gradeid}&buildingId=${buildingid}`, 'staff_tickets_data', setAllReportData, signal),
            ];
            try {
                const responses = await Promise.all(apiCalls);
            } catch (error) {
                log.error(error)
            } finally {
                setOnload((prevState) => ({ ...prevState, StaffOnload: true }))
            }
        }
        if (Tabs?.HelpdeskTickets == "active" && !Onload?.HelpdeskOnload) {
            setAllReportData((prevState) => ({
                ...prevState,
                filter_data: { ...prevState?.filter_data, ...params },
            }))
            const apiCalls = [
                fetchAdminData(`/reports/technology-tickets?schoolId=${LogInSchoolID}&startDate=${formatDateToUsaMMDDYYYY(sdate)}&endDate=${formatDateToUsaMMDDYYYY(edate)}`, 'technology_tickets_data', setAllReportData, signal),
                fetchAdminData(`/reports/maintenance-tickets?schoolId=${LogInSchoolID}&startDate=${formatDateToUsaMMDDYYYY(sdate)}&endDate=${formatDateToUsaMMDDYYYY(edate)}`, 'maintenance_total_tickets_data', setAllReportData, signal),
                fetchAdminData(`/reports/helpdesk-tickets?schoolId=${LogInSchoolID}&startDate=${formatDateToUsaMMDDYYYY(sdate)}&endDate=${formatDateToUsaMMDDYYYY(edate)}`, 'helpdesk_total_tickets_data', setAllReportData, signal),
                fetchAdminData(`/reports/helpdesk-by-building?schoolId=${LogInSchoolID}`, 'helpdesk_ticket_by_buildingfor_report', setAllReportData, signal),
            ];
            try {
                const responses = await Promise.all(apiCalls);
            } catch (error) {
                log.error(error)
            } finally {
                setOnload((prevState) => ({ ...prevState, HelpdeskOnload: true }))
            }
        }
    }

    const isFirstRender = useRef(true);
    useEffect(() => {
        if (!isFirstRender.current) {
            GetAllData(startDate, endDate, grade, building);
        } else {
            isFirstRender.current = false;
        }
    }, [Tabs, Onload, endDate])
    function FuncTabActive(tabKey) {
        setbuilding(0);
        setTabs(prevTabs => {
            return Object.fromEntries(
                Object.entries(prevTabs).map(([key]) => [key, key === tabKey ? "active" : ""])
            );
        });
    }
    return (
        <React.Fragment>
            {Alert}
            <div className="row mx-0 pb-3">
                {Tabs.DeviceReports == 'active' || Tabs.StaffReports == 'active' ?
                    <div className='col-md-3' style={{ placeSelf: "center" }}>
                        <h1 className="PageHeading " >Reports</h1>
                    </div>
                    :
                    <div className='col-md-7' style={{ placeSelf: "center" }}>
                        <h1 className="PageHeading " >Reports</h1>
                    </div>
                }
                <div className={`${(!show_grade_field && (Tabs.DeviceReports == 'active' || Tabs.StaffReports == 'active')) ? 'offset-md-2' : ''} col-md-4 text-end row`}>
                    <div className="col-md-6 d-flex  align-items-center px-0">
                        <label className="px-3"></label>
                        <ReactDatePicker
                            className="form-control me-4 text-center"
                            selected={startDate}
                            onChange={(e) => { setStartDate(e) }}
                            dateFormat="MM/dd/yyyy"
                            maxDate={today}
                        />
                    </div>
                    <div className="col-md-6 d-flex  align-items-center px-0">
                        <label className="px-3">To</label>
                        <ReactDatePicker
                            className="form-control me-4 text-center"
                            selected={endDate}
                            onChange={(e) => { setEndDate(e) }}
                            dateFormat="MM/dd/yyyy"
                            maxDate={today}
                        />
                    </div>
                </div>
                {Tabs.DeviceReports == 'active' || Tabs.StaffReports == 'active' ?
                    <>
                        {show_grade_field &&
                            <div className="col-md-2 py-1 pe-0">
                                <select value={grade} onChange={(e) => { setgrade(e.target.value) }}>
                                    <option value="null">Filter by Grade</option>
                                    {GradeArray.map((item, j) => (
                                        <option value={item.id} key={j}>
                                            {item.grade}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        }
                        <div className="col-md-2 py-1 pe-0">
                            <select value={building} onChange={(e) => { setbuilding(e.target.value) }}>
                                <option value="0">Filter by Building</option>
                                {BuildingArray.map((item, j) => (
                                    <option value={item.id} key={j}>
                                        {item.building}
                                    </option>
                                ))}
                            </select>
                        </div>
                    </> : null
                }
                <div className="col-md-1 py-1 pe-0">
                    <button className="btn btn-secondary w-100 filter-apply" onClick={() => {
                        setOnload({
                            DeviceOnload: false,
                            StaffOnload: false,
                            TechnologyOnload: false,
                            MaintenanceOnload: false,
                        })
                    }}>Apply</button>
                </div>
            </div>
            <div className='GridBox px-3'>
                <div className="row p-3">
                    <ul className="nav nav-tabs ">
                        {Object.entries({
                            DeviceReports: "Device Reports",
                            StaffReports: "Staff Reports",
                            HelpdeskTickets: UserData.helpdeskUpdatedFlag ? "Help Desk Reports" : "Support Tickets",
                        }).map(([key, value], index) => (
                            <Tab key={index} isActive={Tabs[key] == 'active'}
                                label={value} onClick={() => FuncTabActive(key)} />
                        ))}
                    </ul>
                </div>
                <ReportDataContext.Provider value={{ AllReportData }}>
                    {Tabs.DeviceReports == "active" && (
                        <DeviceReportsIndex setAlerts={setAlerts} />
                    )}
                    {Tabs.StaffReports == "active" && (
                        <StaffReportsIndex setAlerts={setAlerts} />
                    )}
                    {Tabs.HelpdeskTickets == "active" && (
                        <>
                            <TechTicketsIndex />
                            <MaintenanceIndex />
                            {UserData.helpdeskUpdatedFlag &&
                                <OtherHelpdeskTickets setAlerts={setAlerts} />
                            }
                            <OpenHelpdeskTicketsbyBuilding setAlerts={setAlerts} AllReportData={AllReportData.helpdesk_ticket_by_buildingfor_report} />
                        </>
                    )}
                </ReportDataContext.Provider>
            </div>
        </React.Fragment>
    )
}
